<template>
  <div
    class="container has-padding-right-15-mobile has-padding-left-15-mobile has-padding-right-80 has-padding-left-80 pb-4"
  >
    <div
      class="is-full-width rounded-10 background-image"
      :style="{
        backgroundImage: `url(${
          trainingInfo.cover_image || trainingInfo.image
        })`
      }"
    >
      <div
        class="black-gradient title hero-body is-left-marginless-mobile pb-2 pt-12 rounded-10 is-flex is-flex-direction-row is-content-space-between align-end is-flex-wrap"
      >
        <div class="is-flex is-flex-wrap is-flex-direction-column gap-1">
          <div
            class="has-text-white is-size-4 has-text-weight-bold line-height-32px"
          >
            {{
              this.$i18n.locale === 'ne'
                ? trainingInfo.title_ne
                : trainingInfo.title
            }}
          </div>
          <div v-if="trainingInfo.show_enroll_form">
            <span
              class="is-narrow button has-margin-top-10-mobile is-jobseeker white--text mb-2"
              @click="$options.scrollToContent('training-form')"
            >
              {{ $t('enrollNow') }}
            </span>
          </div>
        </div>
        <div class="has-text-white is-size-6 has-text-weight-normal mt-3">
          {{ $t('Views') }}: {{ get(trainingInfo, 'view_count') || '0' }}
        </div>
      </div>
    </div>
    <div
      class="columns gap-1 ml-0 has-margin-right-15 mt-3"
      :class="screen === 'mobile' ? 'mr-0' : ''"
    >
      <div
        class="column mb-3 is-left-marginless-mobile is-margin-top-30-mobile box is-shadowless outline is-8"
      >
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="columns is-multiline has-padding-top-10 is-mobile">
              <span v-if="$route.params.slug != '-9'">
                <div
                  v-if="
                    get(trainingInfo, 'start_at') && !trainingInfo.is_upcoming
                  "
                  class="column is-4-desktop is-12-mobile"
                >
                  <div class="columns is-mobile">
                    <div class="column is-narrow has-text-error-color">
                      <vue-icon-base
                        height="24"
                        width="24"
                        :path="$options.icons[$kc('uniCalender')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column is-narrow is-size-7 is-left-paddingless">
                      <div class="has-text-grey">{{ $t('startDate') }}:</div>
                      <div class="has-text-weight-bold has-text-error-color">
                        {{
                          `${$options.getHumanizeDate(
                            trainingInfo.start_at
                          )}, ${trainingInfo.start_at.substring(11, 19)}`
                        }}
                      </div>
                      <div class="has-text-subtitle-color">
                        {{
                          get(trainingInfo, 'data.duration') +
                          ' ' +
                          get(trainingInfo, 'data.unit')
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    get(trainingInfo, 'end_at') && !trainingInfo.is_upcoming
                  "
                  class="column is-4-desktop is-12-mobile"
                >
                  <div class="columns is-mobile">
                    <div class="column is-narrow has-text-error-color">
                      <vue-icon-base
                        height="24"
                        width="24"
                        :path="$options.icons[$kc('uniCalender')]"
                      >
                      </vue-icon-base>
                    </div>
                    <div class="column is-narrow is-size-7 is-left-paddingless">
                      <div class="has-text-grey">{{ $t('endDate') }}:</div>
                      <div class="has-text-error-color has-text-weight-bold">
                        {{
                          `${$options.getHumanizeDate(
                            trainingInfo.end_at
                          )}, ${trainingInfo.end_at.substring(11, 19)}`
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </span>

              <div class="column is-4-desktop is-12-mobile">
                <div class="columns is-mobile">
                  <div class="column is-narrow has-text-error-color">
                    <vue-icon-base
                      height="24"
                      width="24"
                      :path="$options.icons[$kc('uniMapMarker')]"
                    >
                    </vue-icon-base>
                  </div>
                  <div class="column is-left-paddingless is-size-7">
                    <div class="has-text-grey">{{ $t('venue') }}:</div>
                    <div class="has-text-weight-bold wrap has-text-error-color">
                      {{ get(trainingInfo, 'data.venue') || 'N/A' }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  trainingInfo &&
                  trainingInfo.data &&
                  trainingInfo.data.show_training_cost
                "
                class="column is-4-desktop is-12-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-narrow has-text-error-color">
                    <vue-icon-base
                      height="24"
                      width="24"
                      :path="$options.icons[$kc('uniMoneyBill')]"
                    >
                    </vue-icon-base>
                  </div>
                  <div class="column is-size-7 is-left-paddingless">
                    <div class="has-text-grey">{{ $t('price') }}:</div>
                    <div
                      v-if="get(trainingInfo, 'data.price') > 0"
                      class="has-text-error-color has-text-weight-bold"
                    >
                      {{
                        'NRs. ' +
                        parseInt(
                          get(trainingInfo, 'data.price')
                        ).toLocaleString('en-IN')
                      }}
                    </div>
                    <div
                      v-else
                      class="has-text-weight-bold has-text-error-color"
                    >
                      {{ $t('Free') }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  trainingInfo &&
                  trainingInfo.data &&
                  trainingInfo.data.show_session
                "
                class="column is-4-desktop is-12-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-narrow has-text-error-color">
                    <vue-icon-base
                      height="24"
                      width="24"
                      :path="$options.icons[$kc('uniFileEditAlt')]"
                    >
                    </vue-icon-base>
                  </div>
                  <div class="column is-size-7 is-left-paddingless">
                    <div class="has-text-grey">{{ $t('noOfSessions') }}:</div>
                    <div class="has-text-error-color has-text-weight-bold">
                      {{ get(trainingInfo, 'data.no_of_sessions') || 'N/A' }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  trainingInfo &&
                  trainingInfo.data &&
                  trainingInfo.data.show_trainee_group
                "
                class="column is-4-desktop is-12-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-narrow has-text-error-color">
                    <vue-icon-base
                      height="24"
                      width="24"
                      :path="$options.icons[$kc('uniTraining')]"
                    >
                    </vue-icon-base>
                  </div>
                  <div class="column is-size-7 is-left-paddingless">
                    <div class="has-text-grey">{{ $t('Training Group') }}:</div>
                    <div class="has-text-error-color has-text-weight-bold">
                      {{ get(trainingInfo, 'data.trainee_group') || '-' }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="!trainingInfo.is_upcoming"
                class="column is-4-desktop is-12-mobile"
              >
                <div class="columns is-mobile">
                  <div class="column is-narrow has-text-error-color">
                    <vue-icon-base
                      height="24"
                      width="24"
                      :path="$options.icons[$kc('uniCalender')]"
                    >
                    </vue-icon-base>
                  </div>
                  <div class="column is-narrow is-size-7 is-left-paddingless">
                    <div class="has-text-grey">
                      {{ $t('lastDateOfRegistration') }}:
                    </div>
                    <div
                      v-if="get(trainingInfo, 'data.last_date_of_registration')"
                      class="has-text-error-color has-text-weight-bold"
                    >
                      {{
                        $options.getHumanizeDate(
                          get(trainingInfo, 'data.last_date_of_registration')
                        ) +
                        ', ' +
                        get(
                          trainingInfo,
                          'data.last_date_of_registration'
                        ).substring(11, 19)
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="is-paddingless is-marginless" />
            <div
              class="column has-text-error-color has-text-weight-bold is-left-paddingless-mobile is-size-5 is-bottom-paddingless"
            >
              {{ $t('Description') }}
            </div>
            <div
              v-if="trainingInfo.description"
              class="has-min-height-170 column has-text-justified has-text-description-color is-right-paddingless-mobile is-left-paddingless-mobile"
              v-html="modifyBlogBody(trainingInfo.description)"
            ></div>
          </div>
          <add-this
            class="column has-text-right pb-5 pr-1"
            :class="trainingInfo.is_upcoming ? 'has-margin-top-80-desktop' : ''"
          />
        </div>
      </div>
      <div
        class="column has-height-250 is-bottom-marginless-mobile has-padding-left-30-mobile box is-shadowless outline is-4"
      >
        <div
          class="has-text-weight-bold is-size-5 has-text-error-color has-margin-bottom-30 has-margin-top-5"
        >
          {{ $t('enquireNow') }}
        </div>
        <div
          v-for="(detail, index) in enquiryInfo"
          :key="index"
          class="has-margin-bottom-40"
        >
          <div
            class="has-text-weight-bold has-text-error-color has-margin-bottom-0 title is-6"
          >
            {{ detail.name }}
          </div>
          <div class="subtitle is-6 is-bottom-marginless">
            {{ detail.position }}
          </div>
          <div class="columns has-margin-top-5 is-mobile">
            <div
              class="column is-bottom-paddingless has-text-subtitle-color is-narrow"
            >
              <vue-icon-base
                height="20"
                class="has-text-error-color"
                width="20"
                :path="$options.icons[$kc('uniPhone')]"
              >
              </vue-icon-base>
            </div>
            <div
              class="column is-narrow is-left-paddingless is-bottom-paddingless"
            >
              <div class="has-text-grey is-size-7">{{ $t('Phone') }}:</div>
              <div class="has-text-subtitle-color is-size-7">
                {{ detail.phone }}
              </div>
            </div>
          </div>
          <div class="columns is-top-paddingless is-mobile">
            <div class="column is-narrow has-text-subtitle-color">
              <vue-icon-base
                height="20"
                width="20"
                :path="$options.icons[$kc('uniEnvelope')]"
              >
              </vue-icon-base>
            </div>
            <div class="column is-narrow is-left-paddingless">
              <div class="has-text-grey is-size-7">{{ $t('Email') }}:</div>
              <div class="has-text-subtitle-color is-size-7">
                {{ detail.email }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="trainingInfo.show_enroll_form"
      id="training-form"
      class="container mb-2"
    >
      <div>
        <div class="is-mobile mt-3 box is-shadowless outline">
          <div class="has-text-centered is-size-4 has-text-weight-bold py-4">
            {{ $t('Submit your details to apply for this training') }}
          </div>
          <div
            v-if="trainingInfo && trainingInfo.title"
            class="has-padding-left-25 has-padding-right-25 has-padding-left-10-mobile has-padding-right-10-mobile"
          >
            <enroll-details :training="trainingInfo"></enroll-details>
          </div>
        </div>
      </div>
    </div>
    <div v-if="trainings.length" class="is-top-paddingless is-mobile">
      <div class="columns">
        <div
          class="column title has-text-error-color is-4 has-text-centered-mobile is-narrow mt-5"
        >
          {{ $t('similarTraining') }}
        </div>
      </div>
      <div class="columns is-mobile is-centered-mobile is-multiline">
        <div
          v-for="(training, index) in trainings"
          :key="`training-${index}`"
          class="column is-mobile is-12-mobile pointer has-margin-bottom-10-mobile is-3-desktop"
          @click="openDetailPage(training.slug)"
        >
          <vue-hover>
            <template v-slot="{ hover }">
              <div
                class="box is-paddingless outline rounded-10 lift-shadow"
                :class="hover ? '' : 'is-shadowless'"
              >
                <div class="card-image">
                  <figure class="image is-3by2">
                    <img
                      class="border-top-left-radius-10px border-top-right-radius-10px"
                      :src="get(training, 'image')"
                    />
                  </figure>
                  <div
                    v-if="hover"
                    class="modal-background has-opacity-half border-top-left-radius-10px border-top-right-radius-10px"
                  ></div>
                </div>
                <div class="card-content pa-3">
                  <div
                    class="has-text-weight-bold dark-blue--text"
                    :title="training.title"
                  >
                    {{
                      $i18n.locale === 'ne'
                        ? $options.truncateChars(get(training, 'title_ne'), 24)
                        : $options.truncateChars(get(training, 'title'), 24)
                    }}
                  </div>

                  <div v-if="!training.is_upcoming">
                    <div class="is-size-7">
                      {{
                        `${$options.getHumanizeDate(
                          get(training, 'start_at')
                        )} - ${$options.getHumanizeDate(
                          get(training, 'end_at')
                        )}`
                      }}
                    </div>
                    <div class="is-size-7">
                      {{
                        get(training, 'data.duration') +
                          ' ' +
                          get(training, 'data.unit') || 'N/A'
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vue-hover>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { truncateChars } from '@/helpers/utils/common'
import VueHover from '@/components/Commons/VueHover'
import { getHumanizeDate } from '@/helpers/utils/date'
import AddThis from '@/components/Commons/AddThis'
import EnrollDetails from '@/components/Accounts/EnrollDetails'
import {
  uniCalender,
  uniMapMarker,
  uniMoneyBill,
  uniPhone,
  uniFileEditAlt,
  uniEnvelope,
  uniTraining
} from '@/helpers/icons'
import VueIconBase from '@/components/Commons/VueIconBase'
import { scrollToContent } from '@/helpers/utils/common.js'
import { mapGetters } from 'vuex'
export default {
  getHumanizeDate,
  truncateChars,
  icons: {
    uniCalender,
    uniMapMarker,
    uniMoneyBill,
    uniPhone,
    uniFileEditAlt,
    uniEnvelope,
    uniTraining
  },
  scrollToContent,
  components: { VueIconBase, AddThis, VueHover, EnrollDetails },
  data() {
    return {
      trainingInfo: {},
      trainings: [],
      activeIndex: 1,
      enquiryInfo: []
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' })
  },
  mounted() {
    this.getData()
  },
  methods: {
    modifyBlogBody(url) {
      let endpoint = url
      endpoint = endpoint.replace('oembed', 'iframe')
      const iframeRegex = /<iframe[^>]+src="([^"]+)"/g
      const imgRegex = /<img[^>]+src="([^"]+)"/g
      endpoint = endpoint.replace(iframeRegex, (match, src) => {
        return match.replace(src, `${src}" width="100%" height="370"`)
      })
      endpoint = endpoint.replace(imgRegex, (match, src) => {
        return match.replace(src, `${src}" width="100%" height="370"`)
      })
      endpoint = endpoint.replace('watch?v=', 'embed/')
      endpoint = endpoint.replace(
        /<p>(https?:\/\/[^<]+)<\/p>/g,
        (match, url) => {
          return `<a href="${url}" target="_blank">${url}</a>`
        }
      )
      return endpoint
    },
    getData() {
      this.$axios
        .get(`/api/v1/training/${this.$route.params.slug}/`)
        .then(({ data }) => {
          this.trainingInfo = data
          if (
            data &&
            data.contact_person &&
            Object.keys(data.contact_person).length
          ) {
            this.enquiryInfo = [
              {
                name: data.contact_person.name,
                position: '',
                email: data.contact_person.email,
                phone: data.contact_person.phone_number
              }
            ]
          } else {
            this.enquiryInfo = [
              {
                name: 'Rojgari Services Private Limited',
                position: 'Shantinagar, Kathmandu',
                email: 'info@rojgari.com',
                phone: '01-4106540'
              }
            ]
          }
          this.getTrainings()
        })
    },
    getTrainings() {
      const filter =
        this.trainingInfo && this.trainingInfo.is_upcoming
          ? 'upcoming'
          : 'current'
      const contentUrl = `/api/v1/training/?status=${filter}`
      this.$axios.get(contentUrl).then(({ data }) => {
        this.trainings = data.results
          .filter(x => x.slug !== this.$route.params.slug)
          .slice(0, 4)
      })
    },
    openDetailPage(slug) {
      this.$router.push(
        this.localePath({
          name: 'training-slug',
          params: { slug }
        })
      )
    }
  },
  head() {
    return {
      title: `Trainings | Rojgari`
    }
  }
}
</script>
<style lang="css">
.has-min-height-170 {
  min-height: 170px;
}
.has-height-250 {
  height: 250px;
}
.has-opacity-half {
  opacity: 0.5;
}
.black-gradient {
  background: linear-gradient(
    179deg,
    transparent,
    rgb(255 124 58 / 10%) 37%,
    rgb(0 0 0 / 85%)
  );
  height: 15rem;
}
.background-image {
  background-repeat: no-repeat;
}
</style>
